import {Link, useParams} from "react-router-dom";
import { useTitle } from "fearless-common-ui";
import useGet from "../../../components/hooks/useGet";
import {concepts, File, Reagent} from "fearless-common";
import {DataRow, Pages} from "../../../components/layout";
import {adminRoutes} from "../../../utils/routes";
import moment from "moment/moment";
import {defaultDateTimeFormat} from "../../../utils/date";
import Loading from "../../../components/Loading";
import React from "react";
import UrlTabs from "../../../components/UrlTabs";
import Photo51FileVersionsTable from "./Photo51FileVersionsTable";
import {BackendVersion} from "fearless-common/src/backendModels";
import {BoxArrowUpRight} from "react-bootstrap-icons";

/**
 * Admin page to see the details of a Photo51 file.
 *
 * @constructor
 */
export default function AdminFile() {
  const { fileId } = useParams() as { fileId: string };
  const { data: file, isLoading } = useGet<File & { reagent: Reagent; versions: BackendVersion[]  }>({
    endpoint: `/admin/files/${fileId}?_withTrashed=1&_with[]=versions.user&_with[]=reagent`
  });

  useTitle(`Admin ${concepts.Group}`);

  return (
    <Pages.Centred>
      <Pages.BackButton href={adminRoutes.files}>Files</Pages.BackButton>
      <h1>File: {file?.name}</h1>
      <div className="d-flex gap-4 mb-3">
        {file?.deleted_at && <span>Archived at: {moment(file?.deleted_at).format(defaultDateTimeFormat)}</span>}
        <span>Signed up: {moment(file?.created_at).format(defaultDateTimeFormat)}</span>
        <span>Last updated: {moment(file?.updated_at).format(defaultDateTimeFormat)}</span>
      </div>
      {isLoading && <Loading />}
      <UrlTabs
        baseUrl={(k) => adminRoutes.file(fileId, k)}
        queryParameter="tab"
        defaultActiveKey="details"
      >
        <UrlTabs.Tab title="Details" eventKey="details">
          <UrlTabs.TabContent>
            {file && (
              <>
                <DataRow label="File name">{file.name}</DataRow>
                <DataRow label="Reagent name">
                  {file.reagent ? (
                    <>
                      {file.reagent?.name}&nbsp;
                      [ID {file.reagent?.id}]
                      <Link to={adminRoutes.reagent(file.reagent?.id)}>
                        <BoxArrowUpRight />
                      </Link>
                    </>
                  ) : <i className="text-muted">No reagent</i>}
                </DataRow>
              </>
            )}
          </UrlTabs.TabContent>
        </UrlTabs.Tab>
        <UrlTabs.Tab title="Versions" eventKey="versions">
          <UrlTabs.TabContent>
            {file?.versions && Array.isArray(file?.versions) && (
              <Photo51FileVersionsTable versions={file.versions} />
            )}
          </UrlTabs.TabContent>
        </UrlTabs.Tab>
      </UrlTabs>

    </Pages.Centred>
  );
}
